/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneNumberBody
 */
export interface PhoneNumberBody {
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberBody
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberBody
     */
    nationalNumber: string;
}

export function PhoneNumberBodyFromJSON(json: any): PhoneNumberBody {
    return PhoneNumberBodyFromJSONTyped(json, false);
}

export function PhoneNumberBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneNumberBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'nationalNumber': json['nationalNumber'],
    };
}

export function PhoneNumberBodyToJSON(value?: PhoneNumberBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countryCode': value.countryCode,
        'nationalNumber': value.nationalNumber,
    };
}


